import cookieService from './Cookies.service';
import RdsUser from './../models/rdsUser.model';
import store from '../stores';
import { eventBus } from '../services/EventBus';
import gApiWrapper from '../services/GapiWrapper.service';
import tornelliUtil from '../services/TornelliUtil.service';
let _user = initUser();
class UserService {
  get user() {
    return _user;
  }
  set user(user) {
    _user = user;
    store.get('rdsUser', user.id, true).then((u) => {
      console.log('set user');
      if (u) {
        console.log('setUser');
        _user = u;
        console.log(_user);
        if (!u.badge && window.cordova) {
          tornelliUtil.getUserCode(_user).then(console.log);
        }
        if (u.photos.length === 0 || u.photos[0] === 'https://rds-life-dev-templates.s3-eu-west-1.amazonaws.com/usersImg/default-user.jpg') {
          u.photos = user.photos;
        }
        eventBus.$emit('userUpdated', _user);
        cookieService.setCookie('user', u, 15);
        store.update('rdsUser', u.id, u);
      }
    }).catch(e => {
      console.error(e);
    });
  }
  updateUser(user) {
    store
      .update('rdsUser', user.id, user)
      .then(u => {
        _user = u;
        eventBus.$emit('userUpdated', _user);
        this.showForm = false;
      })
      .catch(e => {
        console.warn(e);
      });
  }
  login(user) {
    return new Promise((resolve, reject) => {
      console.log('login');
      store.get('rdsUser', user.id, true).then((u) => {
        if (u) {
          console.log('setUser');
          _user = u;
          if (!u.badge && window.cordova) {
            tornelliUtil.getUserCode(_user).then(badgeId => {
              _user.badge = badgeId;
              eventBus.$emit('userUpdated', _user);
              cookieService.setCookie('user', u, 15);
              store.update('rdsUser', u.id, u);
            });
          }
          if (u.photos.length === 0 || u.photos[0] === 'https://rds-life-dev-templates.s3-eu-west-1.amazonaws.com/usersImg/default-user.jpg') {
            u.photos = user.photos;
          }
          console.log(_user);
          eventBus.$emit('userUpdated', _user);
          cookieService.setCookie('user', u, 15);
          store.update('rdsUser', u.id, u);
          resolve(_user);
        }
      }).catch(e => {
        console.error(e);
        reject(e);
      });
    });
  }

  isAuthenticated() {
    console.log('isAuthenticated', this.user);
    return Object.entries(this.user).length > 0 && !!this.user.id;
  }
  toggleLike(type, id) {
    const added = _user.likes[type].indexOf(id) === -1 ? _addLike(type, id) : _removeLike(type, id);
    this.user = _user;
    return added;
  }
  addLike = _addLike;
  removeLike = _removeLike;
  logout = _logout;
  softLogout = _softLogout;
}

function _softLogout() {
  cookieService.deleteCookie('user');
}

function _logout() {
  cookieService.deleteCookie('user');
  if (window.cordova && window.plugins) {
    window.skipAutoLogin = true;
    window.plugins.googleplus.logout(
      function (msg) {
        console.log(msg); // do something useful instead of alerting
      },
      function (msg) {
        console.log(msg); // do something useful instead of alerting
      }
    );
  }
  eventBus.$emit('userUpdated', _user);
  _user = {};
}

function _addLike(type, id) {
  _user.likes[type].push(id);
  return true;
}
function _removeLike(type, id) {
  _user.likes[type].splice(_user.likes[type].indexOf(id), 1);
  return false;
}

function initUser() {
  const cookieUser = cookieService.getCookie('user');
  let user = cookieUser != null ? new RdsUser(cookieUser) : {};
  return user;
}

gApiWrapper.init().then(() => {
  const isSignedIn = gApiWrapper.auth2.isSignedIn.get();
  if (!isSignedIn) {
    _logout();
  }
}).catch(() => { });

const userService = new UserService();
if (window.cordova) {
  userService.user = {};
} else {
  userService.user = _user;
}

export default userService;
